<template>
        <grid-x col="1fr 1fr" row="1fr" gap="2em">
          <div class="redirect-strings">
            <h1>Redirect Strings</h1>
            <div class="redirect-input">
              <div class="input-box">
                <input v-model="newRedirectString.from" type="text" placeholder="From">
              </div>
              <div class="input-box">
                <input v-model="newRedirectString.to" type="text" placeholder="To">
              </div>
              <button style="margin-top:20px;" @click="createRedirectString">Create Redirect String</button>
            </div>
            <div class="flex redirect">
              <span class="flex-3">
                <b>From</b>
              </span>
              <span class="flex-3">
                <b>To</b>
              </span>
              <span class="flex-1"></span>
            </div>
            <div
              class="draggable-items redirect flex flex-space-between center-flex-y"
              v-for="(item,key) in redirectStrings"
              :key="key"
            >
              <span class="flex-3">{{item.from}}</span>
              <span class="flex-3">{{item.to}}</span>
              <span class="flex-1">
                <button v-on:click="removeRedirectString(item)">Remove</button>
              </span>
            </div>
          </div>
          <div class="redirect-regex">
            <h1>Redirect Regex</h1>
            <div class="redirect-input">
              <div class="input-box">
                <input v-model="newRedirectRegex.from" type="text" placeholder="From">
              </div>
              <div class="input-box">
                <input v-model="newRedirectRegex.to" type="text" placeholder="To">
              </div>
              <button style="margin-top:20px;" @click="createRedirectRegex">Create Redirect Regex</button>
            </div>
            <div class="flex redirect">
              <span class="flex-3">
                <b>From</b>
              </span>
              <span class="flex-3">
                <b>To</b>
              </span>
              <span class="flex-1"></span>
            </div>
            <div
              class="draggable-items redirect flex center-flex-y"
              v-for="(item,key) in redirectRegex"
              :key="key"
            >
              <span class="flex-3">{{item.from}}</span>
              <span class="flex-3">{{item.to}}</span>
              <span class="flex-1">
                <button v-on:click="removeRedirectRegex(item)">Remove</button>
              </span>
            </div>
          </div>
        </grid-x>

</template>
<style scoped>
.draggable-items.redirect {
  width: 100%;
  flex-wrap: wrap;
}
.redirect > span:first-of-type {
  padding-left: 1em;
}
.redirect-input {
  margin-bottom: 1em;
}
</style>

<script>
import Vue from "vue";
import firebase from "firebase";
import gridX from "../widgets/gridX";
export default {
  name: "redirects",
  components: {
    gridX
  },
  props: ["storage"],
  data() {
    firestore = firebase.firestore();
    return {
      newRedirectRegex: {
        from: "",
        to: ""
      },
      newRedirectString: {
        from: "",
        to: ""
      },
    }
  },
  firestore() {
    return {
      redirectStrings: firestore
        .collection("redirects")
        .doc("strings")
        .collection("list"),
      redirectRegex: firestore
        .collection("redirects")
        .doc("regex")
        .collection("list")
    };
  },
  methods: {
    createRedirectRegex: function() {
      this.$firestore.redirectRegex.add(this.newRedirectRegex);
    },
    createRedirectString: function() {
      this.$firestore.redirectStrings.add(this.newRedirectString);
    },
    removeRedirectRegex: function(item) {
      this.$firestore.redirectRegex.doc(item[".key"]).delete();
    },
    removeRedirectString: function(item) {
      this.$firestore.redirectStrings.doc(item[".key"]).delete();
    }
  }
}
</script>



// WEBPACK FOOTER //
// redirects.vue?0134642c